<template>
  <!-- Upload content -->
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9">
            <v-btn class="mr-2" to="/admin/archetypes/add" v-if="listView">Add</v-btn>
            <v-btn class="mr-2" to="/admin/archetypes" v-else >Close</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col :cols="containerWidth">
      <h3 class="mb-4">Brand personalities</h3>
      <v-row dense>
        <v-col
          v-for="(card, index) in items"
          :key="`card-${index}`"
          :cols="cardWidth"
        >
          <card-tile path="/admin/archetypes" :card="card" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="4">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import router from "@/router";
import CardTile from "./CardTile";

export default {
  name: "AdminArchetypeList",
  data() {
    return {
      collection: fb.archetypesCollection,
      items: null,
      returnRoute: 'AdminArchetypesList'
    };
  },
  components: {
    CardTile
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    listView() {
      return this.$route.name == "AdminArchetypesList" ? true : false;
    },
    containerWidth() {
      return this.listView ? "12" : "8";
    },
    cardWidth() {
      return this.listView ? "3" : "4";
    },
  },
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      console.log('get items')
      this.collection
        .orderBy("createdOn", "desc")
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    deleteItem(id) {
      this.collection
        .doc(id)
        .delete()
        .then(() => {
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    }
  },
};
</script>
